/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetUserDocument = gql`
    query GetUser($companyId: Int!, $branchId: Int!) {
  user {
    id
    email
    companies {
      id
      name
      address
      phone
      deleted
      paidFeaturesPaginated {
        totalCount
      }
      bookingQrLink
      isPremiumOn
    }
    company(id: $companyId) {
      branches(id: $branchId) {
        id
        name
        address
        bookingQrLink
        currencyCode
        deleted
        timeZone
        onlineRegistration
        removedOfTariff
        country {
          id
          continentName
          isInEuropeanUnion
          isoCode
          localeCode
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserForCreateOwnerPageDocument = gql`
    query GetUserForCreateOwnerPage {
  user {
    companies {
      id
      branches {
        id
      }
    }
    currentBranch {
      id
    }
  }
}
    `;

/**
 * __useGetUserForCreateOwnerPageQuery__
 *
 * To run a query within a React component, call `useGetUserForCreateOwnerPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForCreateOwnerPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForCreateOwnerPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserForCreateOwnerPageQuery(baseOptions?: Apollo.QueryHookOptions<GetUserForCreateOwnerPageQuery, GetUserForCreateOwnerPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserForCreateOwnerPageQuery, GetUserForCreateOwnerPageQueryVariables>(GetUserForCreateOwnerPageDocument, options);
      }
export function useGetUserForCreateOwnerPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserForCreateOwnerPageQuery, GetUserForCreateOwnerPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserForCreateOwnerPageQuery, GetUserForCreateOwnerPageQueryVariables>(GetUserForCreateOwnerPageDocument, options);
        }
export function useGetUserForCreateOwnerPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserForCreateOwnerPageQuery, GetUserForCreateOwnerPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserForCreateOwnerPageQuery, GetUserForCreateOwnerPageQueryVariables>(GetUserForCreateOwnerPageDocument, options);
        }
export type GetUserForCreateOwnerPageQueryHookResult = ReturnType<typeof useGetUserForCreateOwnerPageQuery>;
export type GetUserForCreateOwnerPageLazyQueryHookResult = ReturnType<typeof useGetUserForCreateOwnerPageLazyQuery>;
export type GetUserForCreateOwnerPageSuspenseQueryHookResult = ReturnType<typeof useGetUserForCreateOwnerPageSuspenseQuery>;
export type GetUserForCreateOwnerPageQueryResult = Apollo.QueryResult<GetUserForCreateOwnerPageQuery, GetUserForCreateOwnerPageQueryVariables>;
export const GetUserForGlobalVarDocument = gql`
    query GetUserForGlobalVar($branchId: Int, $userBranchId: Int) {
  user(branchId: $userBranchId) {
    id
    email
    companies {
      id
      name
      branches(id: $branchId) {
        id
        name
        company {
          id
          name
        }
      }
    }
    currentBranch {
      id
      company {
        id
      }
    }
  }
}
    `;

/**
 * __useGetUserForGlobalVarQuery__
 *
 * To run a query within a React component, call `useGetUserForGlobalVarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForGlobalVarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForGlobalVarQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      userBranchId: // value for 'userBranchId'
 *   },
 * });
 */
export function useGetUserForGlobalVarQuery(baseOptions?: Apollo.QueryHookOptions<GetUserForGlobalVarQuery, GetUserForGlobalVarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserForGlobalVarQuery, GetUserForGlobalVarQueryVariables>(GetUserForGlobalVarDocument, options);
      }
export function useGetUserForGlobalVarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserForGlobalVarQuery, GetUserForGlobalVarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserForGlobalVarQuery, GetUserForGlobalVarQueryVariables>(GetUserForGlobalVarDocument, options);
        }
export function useGetUserForGlobalVarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserForGlobalVarQuery, GetUserForGlobalVarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserForGlobalVarQuery, GetUserForGlobalVarQueryVariables>(GetUserForGlobalVarDocument, options);
        }
export type GetUserForGlobalVarQueryHookResult = ReturnType<typeof useGetUserForGlobalVarQuery>;
export type GetUserForGlobalVarLazyQueryHookResult = ReturnType<typeof useGetUserForGlobalVarLazyQuery>;
export type GetUserForGlobalVarSuspenseQueryHookResult = ReturnType<typeof useGetUserForGlobalVarSuspenseQuery>;
export type GetUserForGlobalVarQueryResult = Apollo.QueryResult<GetUserForGlobalVarQuery, GetUserForGlobalVarQueryVariables>;
export const GetCompanyGlobalDocument = gql`
    query GetCompanyGlobal($companyId: Int!, $email: String, $branchId: Int!) {
  user {
    id
    email
    role(companyId: $companyId) {
      id
      name
    }
    company(id: $companyId) {
      id
      currency {
        id
        currencySign
      }
      name
      address
      phone
      deleted
      paidFeaturesPaginated {
        totalCount
      }
      bookingQrLink
      isPremiumOn
      category {
        id
        type
      }
      branches(id: $branchId) {
        employeesPaginated(email: $email) {
          employees {
            userBranchRelations {
              branch {
                id
              }
              role {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyGlobalQuery__
 *
 * To run a query within a React component, call `useGetCompanyGlobalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyGlobalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyGlobalQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      email: // value for 'email'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetCompanyGlobalQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyGlobalQuery, GetCompanyGlobalQueryVariables> & ({ variables: GetCompanyGlobalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyGlobalQuery, GetCompanyGlobalQueryVariables>(GetCompanyGlobalDocument, options);
      }
export function useGetCompanyGlobalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyGlobalQuery, GetCompanyGlobalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyGlobalQuery, GetCompanyGlobalQueryVariables>(GetCompanyGlobalDocument, options);
        }
export function useGetCompanyGlobalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyGlobalQuery, GetCompanyGlobalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyGlobalQuery, GetCompanyGlobalQueryVariables>(GetCompanyGlobalDocument, options);
        }
export type GetCompanyGlobalQueryHookResult = ReturnType<typeof useGetCompanyGlobalQuery>;
export type GetCompanyGlobalLazyQueryHookResult = ReturnType<typeof useGetCompanyGlobalLazyQuery>;
export type GetCompanyGlobalSuspenseQueryHookResult = ReturnType<typeof useGetCompanyGlobalSuspenseQuery>;
export type GetCompanyGlobalQueryResult = Apollo.QueryResult<GetCompanyGlobalQuery, GetCompanyGlobalQueryVariables>;
export const MeUserDocument = gql`
    query MeUser {
  me {
    username
  }
}
    `;

/**
 * __useMeUserQuery__
 *
 * To run a query within a React component, call `useMeUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeUserQuery(baseOptions?: Apollo.QueryHookOptions<MeUserQuery, MeUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeUserQuery, MeUserQueryVariables>(MeUserDocument, options);
      }
export function useMeUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeUserQuery, MeUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeUserQuery, MeUserQueryVariables>(MeUserDocument, options);
        }
export function useMeUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeUserQuery, MeUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeUserQuery, MeUserQueryVariables>(MeUserDocument, options);
        }
export type MeUserQueryHookResult = ReturnType<typeof useMeUserQuery>;
export type MeUserLazyQueryHookResult = ReturnType<typeof useMeUserLazyQuery>;
export type MeUserSuspenseQueryHookResult = ReturnType<typeof useMeUserSuspenseQuery>;
export type MeUserQueryResult = Apollo.QueryResult<MeUserQuery, MeUserQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($companyId: Int!, $branchId: Int!, $userId: Int!, $input: UserInput!, $employeeId: Int, $isCompanyNew: Boolean) {
  updateUser(
    companyId: $companyId
    userId: $userId
    input: $input
    isCompanyNew: $isCompanyNew
  ) {
    id
    email
    company(id: $companyId) {
      branches(id: $branchId) {
        id
        employeesPaginated(id: $employeeId) {
          employees {
            userBranchRelations {
              branch {
                id
              }
              role {
                id
                name
                isOwner
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *      employeeId: // value for 'employeeId'
 *      isCompanyNew: // value for 'isCompanyNew'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export type GetUserQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, email?: string | null, companies?: Array<{ __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, deleted: boolean, bookingQrLink: string, isPremiumOn: boolean, paidFeaturesPaginated: { __typename?: 'PaidFeaturePaginated', totalCount?: number | null } }> | null, company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', id: number, name: string, address: string, bookingQrLink: string, currencyCode: string, deleted: boolean, timeZone: string, onlineRegistration: boolean, removedOfTariff: boolean, country: { __typename?: 'Country', id: string, continentName: string, isInEuropeanUnion: boolean, isoCode: string, localeCode: string, name: string } }> | null } | null } | null };

export type GetUserForCreateOwnerPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserForCreateOwnerPageQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', companies?: Array<{ __typename?: 'CompanyProxy', id: number, branches?: Array<{ __typename?: 'BranchProxy', id: number }> | null }> | null, currentBranch?: { __typename?: 'BranchProxy', id: number } | null } | null };

export type GetUserForGlobalVarQueryVariables = Types.Exact<{
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  userBranchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetUserForGlobalVarQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, email?: string | null, companies?: Array<{ __typename?: 'CompanyProxy', id: number, name: string, branches?: Array<{ __typename?: 'BranchProxy', id: number, name: string, company?: { __typename?: 'CompanyProxy', id: number, name: string } | null }> | null }> | null, currentBranch?: { __typename?: 'BranchProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number } | null } | null } | null };

export type GetCompanyGlobalQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  email?: Types.InputMaybe<Types.Scalars['String']['input']>;
  branchId: Types.Scalars['Int']['input'];
}>;


export type GetCompanyGlobalQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, email?: string | null, role?: { __typename?: 'RoleProxy', id: number, name: string } | null, company?: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, deleted: boolean, bookingQrLink: string, isPremiumOn: boolean, currency?: { __typename?: 'CurrencyProxy', id: number, currencySign?: string | null } | null, paidFeaturesPaginated: { __typename?: 'PaidFeaturePaginated', totalCount?: number | null }, category?: { __typename?: 'CompanyTypeProxy', id: number, type: string } | null, branches?: Array<{ __typename?: 'BranchProxy', employeesPaginated?: { __typename?: 'EmployeePaginated', employees?: Array<{ __typename?: 'EmployeeProxy', userBranchRelations?: Array<{ __typename?: 'UserBranchRelationProxy', branch: { __typename?: 'BranchProxy', id: number }, role: { __typename?: 'RoleProxy', id: number, name: string } }> | null }> | null } | null }> | null } | null } | null };

export type MeUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MeUserQuery = { __typename?: 'Query', me?: { __typename?: 'Me', username: string } | null };

export type UpdateUserMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  userId: Types.Scalars['Int']['input'];
  input: Types.UserInput;
  employeeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isCompanyNew?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserProxy', id: number, email?: string | null, company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', id: number, employeesPaginated?: { __typename?: 'EmployeePaginated', employees?: Array<{ __typename?: 'EmployeeProxy', userBranchRelations?: Array<{ __typename?: 'UserBranchRelationProxy', branch: { __typename?: 'BranchProxy', id: number }, role: { __typename?: 'RoleProxy', id: number, name: string, isOwner: boolean } }> | null }> | null } | null }> | null } | null } };
